module.exports = __webpack_public_path__ + "img/Dantam Hair 37.0dce7127.jpg";